import { __decorate } from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import { VALIDATION_RULES } from "@/constants/ValidationRules";
import { Prop } from "vue-property-decorator";
import { SERVICE_TYPE } from "@/constants/ServiceTypes";
import { LESSON_TYPE } from "@/constants/LessonTypes";
import InstructorTable from '@/classes/InstructorTable';
import { InstructorTableCellType } from '@/enums/InstructorTableCellType';
import _ from 'lodash';
import { isDesktop } from "@/utils/isDesktop";
let AddClientForm = class AddClientForm extends Vue {
    dialog = false;
    errorMessage = '';
    row;
    //#region STEP_1
    service = '';
    serviceTypes = [
        {
            id: SERVICE_TYPE.SKI,
            label: 'Individuální výuka lyžování',
        },
        {
            id: SERVICE_TYPE.SNB,
            label: 'Individuální výuka snowboardingu',
        },
        {
            id: SERVICE_TYPE.WEX,
            label: 'WEX',
        },
    ];
    fromTime = '';
    hours = 1;
    hoursRules = [
        VALIDATION_RULES.REQUIRED,
        VALIDATION_RULES.POSITIVE_NUMBER,
    ];
    voucher = null;
    voucherBlockedValue = 0;
    isPrepaid = false;
    serviceRules = [
        VALIDATION_RULES.REQUIRED,
    ];
    get maxHours() {
        const maxHours = this.prices.reduce((max, price) => {
            return price.data.lessonType === this.lessonType
                && price.data.hourCount > max
                && price.data.studentCount === this.clients.length
                ? price.data.hourCount
                : max;
        }, 0);
        return maxHours <= this.availableHours ? maxHours : this.availableHours;
    }
    //#endregion
    //#region STEP_2
    defaultClient = { name: '', age: null };
    clients = [
        { ...this.defaultClient },
    ];
    nameRules = [
        VALIDATION_RULES.REQUIRED,
    ];
    ageRules = [
        VALIDATION_RULES.REQUIRED,
        VALIDATION_RULES.POSITIVE_NUMBER,
    ];
    dayTimeFrom;
    availableHours;
    addClient() {
        this.validateCombination();
        this.clients.push({ ...this.defaultClient });
    }
    removeClient() {
        this.validateCombination();
        this.clients.pop();
    }
    //#endregion
    //#region STEP_3
    note = '';
    phoneNumber = '';
    phoneNumberRules = [
        VALIDATION_RULES.REQUIRED,
    ];
    sending = false;
    //#endregion
    async open(row, cell = null) {
        await this.$nextTick();
        if (cell) {
            cell = _.cloneDeep(cell);
            this.hours = cell.length;
            this.service = cell.service;
            this.clients = cell.clients;
            this.phoneNumber = cell.phone;
            this.note = cell.note;
            this.voucher = cell.voucher;
            this.voucherBlockedValue = cell.voucherBlockedValue;
            this.isPrepaid = cell.isPrepaid;
        }
        this.row = row;
        this.fromTime = this.dayTimeFrom.format('D. M. Y H:mm');
        this.dialog = true;
    }
    validateCombination() {
        if (this.price === 0
            || (this.clients.length < 1 || this.clients.length > this.maxClients)) {
            this.errorMessage = 'Pro zvolenou kombinaci služby, počtu hodin a počtu klientů neexistuje cena.';
            return false;
        }
        else if (this.hours < 1 || this.hours > this.maxHours) {
            this.errorMessage = 'Pro zvolenou délku lekce není v rozpisu místo.';
            return false;
        }
        this.errorMessage = '';
        return true;
    }
    submit() {
        if (!this.$refs.form.validate()) {
            return;
        }
        if (!this.validateCombination()) {
            return;
        }
        this.$emit('saved', InstructorTable.loadCellFromObject(_.cloneDeep({
            hour: this.dayTimeFrom.hour(),
            length: this.hours,
            service: this.service,
            clients: this.clients,
            phone: this.phoneNumber,
            note: this.note ?? '',
            cellType: InstructorTableCellType.RESERVED,
            isPrepaid: this.isPrepaid,
            voucher: this.voucher?.id ?? null,
            voucherBlockedValue: this.voucherBlockedValue,
        }), this.row));
    }
    reset() {
        this.dialog = false;
        this.clients = [
            { ...this.defaultClient },
        ];
        this.$refs.form.reset();
    }
    get isDesktop() {
        return isDesktop();
    }
    get prices() {
        return this.$store.getters['pricing/active'];
    }
    get lessonType() {
        return [SERVICE_TYPE.SKI, SERVICE_TYPE.SNB].includes(this.service)
            ? LESSON_TYPE.INDIVIDUAL
            : this.service;
    }
    get maxClients() {
        return this.prices.reduce((max, price) => {
            return price.data.lessonType === this.lessonType && price.data.studentCount > max
                ? price.data.studentCount
                : max;
        }, 0);
    }
    get price() {
        const price = this.prices.find(price => price.data.lessonType === this.lessonType
            && price.data.hourCount === this.hours
            && price.data.studentCount === this.clients.length);
        return price ? price.data.price : 0;
    }
};
__decorate([
    Prop({
        required: true,
    })
], AddClientForm.prototype, "dayTimeFrom", void 0);
__decorate([
    Prop({
        required: true,
    })
], AddClientForm.prototype, "availableHours", void 0);
AddClientForm = __decorate([
    Component
], AddClientForm);
export default AddClientForm;
